export const NO_WRONG_ANSWER = -1

export const PROTOCOL_SLIDE_TYPES = {
  ONE: 'PROTOCOL_SLIDE_ONE',
  TWO: 'PROTOCOL_SLIDE_TWO',
  THREE: 'PROTOCOL_SLIDE_THREE',
};

export const SLIDE_GROUP = {
  JOINT_GROUP: 'JOINT_GROUP',
  BOX_GROUP: 'BOX_GROUP',
  JOINT_GROUP_SEQUENCE: 'JOINT_GROUP_SEQUENCE',
  LABEL_BOX_GROUP: 'LABEL_BOX_GROUP',
};

export const SLIDE_NODE = {
  START_NODE: 'START_NODE',
  BOX_DRAG_DROP: 'BOX_DRAG_DROP',
  JOINT_DRAG_DROP: 'JOINT_DRAG_DROP',
  JOINT_PATH_SELECT: 'JOINT_PATH_SELECT',
  END_NODE: 'END_NODE',
};

export const COMPONENT_TYPE = {
  LINK_HEXAGON_MODAL: 'LINK_HEXAGON_MODAL',
  PLAIN_TEXT: 'PLAIN_TEXT',
  BANNER: 'BANNER',
  SUMMARY_TEXT: 'SUMMARY_TEXT',
  REAGENT_DRAG_DROP: 'REAGENT_DRAG_DROP',
  REAGENT_SELECT: 'REAGENT_SELECT',
  RESULT_COMPARISON_GEL: 'RESULT_COMPARISON_GEL',
  RESULT_COMPARISON_PHOTOSYNTHESIS: 'RESULT_COMPARISON_PHOTOSYNTHESIS',
  GEL_DRAG_DROP: 'GEL_DRAG_DROP',
  GEL_DRAG_DROP_QUESTION: 'GEL_DRAG_DROP_QUESTION',
  QUESTION_TABLE: 'QUESTION_TABLE',
  GEL_RESULTS: 'GEL_RESULTS',
  SKIP_SECTION: 'SKIP_SECTION',
  MATERIALS_LIST: 'MATERIALS_LIST',
  TAKEAWAY_MESSAGES: 'TAKEAWAY_MESSAGES',
  PROTOCOL_TABLE_ACTUAL: 'PROTOCOL_TABLE_ACTUAL',
  PROTOCOL_TABLE_IDEAL: 'PROTOCOL_TABLE_IDEAL',
  PROTOCOL_TABLE_IDEAL_GEL: 'PROTOCOL_TABLE_IDEAL_GEL',
  FULL_WIDTH_IMAGE: 'FULL_WIDTH_IMAGE',
  FULL_WIDTH_ANIMATION: 'FULL_WIDTH_ANIMATION',
  OEQ: 'OEQ',
  NEQ: 'NEQ',
  CSCQ: 'CSCQ',
  MSCQ: 'MSCQ',
  DDQ: 'DDQ',
  DNDQ_COLOR: 'DNDQ_COLOR',
  GROUPED_DNDQ: 'GROUPED_DNDQ',
  CSCQ_COLOR: 'CSCQ_COLOR',
  GROUPED_CSCQ: 'GROUPED_CSCQ',
  SINGLE_SELECT_CSCQ: 'SINGLE_SELECT_CSCQ',
  SUB_HEADING: 'SUB_HEADING',
  HEADING: 'HEADING',
  FULL_WIDTH_CARD: 'FULL_WIDTH_CARD',
  SEQUENCE_SLIDER: 'SEQUENCE_SLIDER',
  SLIDER_IMAGE: 'SLIDER_IMAGE',
  COLOR_PREDICTION: 'COLOR_PREDICTION',
  BANNER: 'BANNER',
  VIDEO: 'VIDEO'
};

export const NOTEBOOK_SECTIONS = {
  CONTEXT: 'CONTEXT',
  MATERIALS: 'MATERIALS',
  PREDICTIONS: 'PREDICTIONS',
  PROTOCOL: 'PROTOCOL',
  RESULTS: 'RESULTS',
  REFLECTION: 'REFLECTION',
  SUMMARY: 'SUMMARY'
};

export const VISIBILITY = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
};

export const QUESTION_CONTENTS = {
  QUESTION: 'question',
  QUESTION1: 'question1',
  QUESTION2: 'question2',
  TEXT: 'text',
  IMAGE: 'image',
  FIG_CAPTION: 'figcaption',
  OPTIONS: 'options',
  GROUPED_OPTIONS1: 'groupedOptions1',
  GROUPED_OPTIONS2: 'groupedOptions2',
  ANSWER_STEPS: 'answerSteps',
  SLIDERS: 'sliders',
  TYPED_OPTIONS: 'typedOptions',
  SLIDER_GROUPS: 'sliderGroups',
  CHECKBOXES: 'checkboxes',
  RESPONSE_AREA: 'responseArea',
  NUMERIC_ENTRY: 'numericEntry',

};

export const TOUR_PROPERTIES = {
  NEXT: 'next',
  COMPLETE: 'complete',
  CLOSE: 'close',
  FINISH: 'finished',
  SKIP: 'skip',
  IS_EXPERIMENTAL_DESIGN_FINISHED: 'IS_EXPERIMENTAL_DESIGN_FINISHED',
};
